import { HttpClient } from '@angular/common/http';
import { Component, OnDestroy, OnInit, Inject, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ApiResponse } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import { RoleService } from 'src/app/shareModule/services/roles/role.service';
import { environment } from 'src/environments/environment';
import { CommonService } from 'src/app/shareModule/services/common.service';
import { Location } from '@angular/common';
import { MemberNotificationService } from 'src/app/shareModule/services/member-notification.service';
import { select, Store } from '@ngrx/store';
import { loadUser, selectUser } from 'src/app/shareModule/states/user-details';

import { ChatbotService } from '../../shareModule/component/chat/chatbot/chatbot.service';
import { LocalServiceService } from '../../shareModule/services/local-service.service';
import { AppState } from 'src/app/shareModule/states/app.state';
import { User } from 'src/app/shareModule/models/user.model';
import { ActivatedRoute } from '@angular/router';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { selectAllBizCategory } from 'src/app/shareModule/states/biz-category/biz-category.selector';
import { selectBizShopBanner } from 'src/app/shareModule/states/biz-shop-banner/biz-shop-banner.selector';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { BizShopBanner } from 'src/app/shareModule/models/biz-shop-banner';
import Swal from 'sweetalert2';
import { BizCardComponent } from '../biz-card/biz-card.component';
import { CERTIFICATE_LIST } from '../community/roles/roles.model';

@Component({
  selector: 'app-advanced-settings',
  templateUrl: './advanced-settings.component.html',
  styleUrl: './advanced-settings.component.scss',
})
export class AdvancedSettingsComponent implements OnDestroy, OnInit {
  private destroy$ = new BehaviorSubject<void>(null);
  public superSellerFeatures: Array<any> = [
    'Extra details tab while adding store product',
    'Enable shout tab for product reference',
    'Enable Reference and store URL for store products',
    'Enable seller social media tab',
    'Enable more products',
    'Enable holiday option',
    'Add more product upto 12',
    'Enable Certified option',
    'Enable job posting option',
  ];

  tab: number = 0;
  public enableTemplate: any = false;
  public blocks: any[] = [];
  public userInfo: any = {};
  public userCard: any = false;
  public modalRef: any = null;
  public selectedOTP: any = '';
  public invalidOtp: string = '';
  public charName: string = '';
  public charImage: any = {
    file: null,
    preview: null,
    default: false
  }
  public email: string = '';
  public currentEmail: string = '';
  public postalCode: string = '';
  public currentPostalCode: string = '';
  public phoneNumber: string = '';
  public shortDescription: string = '';
  public imgUrl = environment.ImageUrl;
  public certifiedSelect: any = [
    // { value: 'Tutor', label: 'Tutor' },
    // { value: 'Handyman', label: 'Handyman' },
    // { value: 'Butler', label: 'Butler' },
    // { value: 'Driver', label: 'Driver' },
    // { value: 'Cleaner', label: 'Cleaner' },
    // { value: 'Chef', label: 'Chef' },
  ];
  public certifiedValue: any = [];
  public regionList = [];
  public selectedMemberRegion = '';
  public selectedMemberRegionId = '';
  public buyerContact: any = false;
  public numberOfDayForPostalCodeChange: any = 0;
  public allowTelegramContact: number | boolean = 0;
  public allowBookDriver: number | boolean = 0;
  public addMainAIInMyChat: number | boolean = 0;
  tutorials: boolean = this.sharedService.isBrowser() ? (JSON.parse(localStorage.getItem('tutorials')) || false) : null
  turnOffWhatsapp: any = false;
  showVerificationTelegram = false;
  noIndexProduct: any = false;
  currentUrl: string = '/advanced-settings';
  bgBody: string = 'space'

  private newNotifVal = false;
  public allowBotChat: boolean | number = false;
  public showCardOnProducts: boolean | number = false;
  public sendMeEmailWhenNewChatStarts: boolean | number = false;
  public categoryTabs: any = [
    { name: "Technology", checked: false },
    { name: "Education", checked: false },
    { name: "Services", checked: false },
    { name: "Rental", checked: false },
    { name: "Donations", checked: false },
    { name: "Favorites", checked: false },
  ]

  public AISettingsTab: any = [
    { title: 'Learn' },
    { title: 'Memory' },
  ]
  public hiddenCategoryTab: string = ''
  public referralCode: string = '';
  public level: Number | number = 0;
  public ROLES = CERTIFICATE_LIST;
  public selectedAvatar: string = '';

  public setProfileToDefault(type = 'default') {
    this.local
      .alertConfirm({
        message: 'Are you sure you want to set your profile to default?',
      })
      .then((result) => {
        if (result.value) {
          this.customerService
            .setProfileToDefault({
              referralCode: this.referralCode,
              level: this.level,
              type: type,
            })
            .subscribe(
              (response: any) => {
                this.toastr.success(
                  response.message || 'Profile set to default successfully'
                );

              },
              (e) => {
                this.toastr.error(
                  e.error.message || 'Failed to set profile to default'
                );
              }
            );
        }
      });
  }

  setProfileToAvatar() {
    this.setProfileToDefault('avatar');
  }

  get showMeNotifications() {
    if ('Notification' in window) {
      return (
        (Notification.permission === 'granted' &&
          this.userInfo?.showMeNotificationWeb) ||
        this.newNotifVal
      );
    }
    return false;
  }

  set showMeNotifications(val) {
    if (val) {
      Notification.requestPermission().then((v) => {
        if (val) {
          this.newNotifVal = val;
        }
      });
    } else {
      this.newNotifVal = val;
    }
  }

  onCharImageChange(event: any) {

    if (this.selectedAvatar) {
      fetch(this.selectedAvatar)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.blob();
        })
        .then(blob => {
          this.charImage.file = blob;
          this.charImage.default = true;
          this.charImage.preview = this.selectedAvatar;
        })
        .catch(error => {
          console.error('Error converting selectedAvatar to blob:', error);
        });
    }
  }

  public unblock(id) {
    this.chatbotService.unBlockUser(id);
  }

  // private constructHtml(data) : string{
  //   console.log('Got data', data)
  //   return `
  //   <div class='d-flex flex-column jusify-content-center align-items-center'>
  //       <img class ='mb-3 img-fluid rounded' src="${data.shop_banner ? (this.imgUrl + data.shop_banner) : ( '../../../assets/images/no_card.webp')}"/>
  //       <span>${data.shop_description ?? ''}</span>
  //       <div class='d-flex justify-content-between mt-3'>
  //          <button  class='btn btn-success mr-5' style='background: #cb5dde'><i class="fa-solid fa-share"></i> Share URL</button>
  //          <button class='btn btn-success' style='background: #cb5dde'><i class="fas fa-user-friends"></i> Copy URL</button>
  //       </div>


  //   </div>


  //   `


  // }

  public showBizPopup(data) {
    //  Swal.fire({
    //   showConfirmButton: false,
    //   html: this.(data)
    //  })
    this.modalRef = this.modalService.open(BizCardComponent, {
      size: 'sm'
    })
    const ref: NgbModalRef = this.modalRef
    ref.componentInstance.bizCard = data;
    // ref.componentInstance.shop_link = `https://kachiing.com/share/${data.id}`

  }

  selectedBizCategory: any = { id: '' };

  public selectBizCategory(index) {
    console.log("Selecting biz catgory", index)
    this.selectedBizCategory = index;
    this.getBizInfos()

    // this.location.replaceState(`${this.currentUrl}?page=${index}`);
  }
  public tabChange(index) {
    if (index == this.tab) return;
    this.tab = index;

    this.location.replaceState(`${this.currentUrl}?page=${index}`);
  }

  startTutorials() {
    localStorage.setItem('tutorials', JSON.stringify(true));
    this.sharedService.shepherd('new-user');
  }

  public shopIdList = []
  public bizCards = []

  getBizInfos() {
    //console.log("etting data for category", this.selectBizCategory.name, this.selectBizCategory)
    this.auth.getBizInfos(this.selectedBizCategory.name).subscribe({
      next: (data: any) => {
        console.log({ data })
        this.bizCards = data.userIds
      },
      error: (err) => {
        console.error(err);
        this.toastr.error("Error something went wrong while fetching shopIds")
      }
    })

  }



  public categoryIconMap = {
    POPULAR: "star",
    FOOD: "utensils",
    SERVICES: "concierge-bell",
    HEALTH: "heartbeat",
    BEAUTY: "spa",
    RETAIL: "shopping-cart",
    CAR: "car",
    FINANCE: "dollar-sign",
  };

  public getCategoryList(): void {
    this.store.pipe(select(selectAllBizCategory)).subscribe((response: any) => {
      this.referCategories = structuredClone(response || []);
      console.log("categoriest are ", this.referCategories)

      this.referCategories.map((c) => {
        c["slug"] = c.name.toLowerCase().replace(/ /g, "-");
      });



    });
  }


  constructor(
    private toastr: ToastrService,
    private location: Location,
    private auth: AuthServiceService,
    public roleService: RoleService,
    private customerService: CustomerService,
    public modalService: NgbModal,
    private http: HttpClient,
    public commonService: CommonService,
    private notificationService: MemberNotificationService,
    private store: Store<AppState>,

    private chatbotService: ChatbotService,
    private local: LocalServiceService,
    private route: ActivatedRoute,
    public sharedService: SharedService,
    @Inject('WINDOW') private window
  ) {
    this.chatbotService.blockeUsers.subscribe((data) => {
      this.blocks = data;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  public referCategories = []
  public isBrowser = this.sharedService.isBrowser();

  public openTelegramPhoneConfirmation() {
    if (this.userInfo.isVerified) {
      this.local.confirmYesNo({
        title: 'Telegram phone verification',
        text: 'Do you have an active telegram that uses the same number as your whatsapp',
        icon: 'success'

      }).then(
        rv => {
          if (rv.isConfirmed) {
            this.auth.verifyAppUserPhone().subscribe({
              next: () => {
                this.toastr.success("Registered!")
                this.store.dispatch(loadUser({}));
              },
              error: (err) => {
                console.error(err)
                this.toastr.error("Error something went wrong please try again")
              }
            })
          }
        }
      )


    } else {
      this.local.alertInfo({
        message: "Please verify whatsapp first"
      })
    }
  }

  public allowWhatsappChange() {
    if (this.allowTelegramContact && this.buyerContact) {
      this.allowTelegramContact = 0;
      this.toastr.info("Allowing both telegram and whatsapp is not allowed")
    }

  }

  public getCertificate() {
    this.auth.certificateGet().subscribe((result) => {
      result.body.map((row) => {
        if (!this.certifiedSelect.some(item => item.value === row.role)) {
          this.certifiedSelect.push({
            value: row.role,
            label: row.role,
          });
        }
      })
    })
  }

  public allowTelegramContactChange() {
    if (!this.userInfo.isTelegramVerified) {
      this.local.alertInfo({
        title: 'Telegram Contact',
        message:
          'Please make sure you have verified you telegram phone in super seller(chat settings).',
      });

      this.allowTelegramContact = 0;
      return;

    }
    if (this.allowTelegramContact && this.buyerContact) {
      this.buyerContact = 0;
      this.toastr.info("Allowing both telegram and whatsapp is not allowed")
    }
    if (this.allowTelegramContact) {
      this.local.alertInfo({
        title: 'Telegram Contact',
        message:
          'Please make sure the phone number of your whatsapp has a telegram and is reachable using the phone number.',
      });
    }
  }

  carouselOptions: any = {
    spaceBetween: 10,
    slidesPerView: "auto",
    pagination: false,
  };


  ngOnInit(): void {
    this.getBitTelegramRegisteration();
    this.getCategoryList();
    this.commonService.regionObserver.subscribe((resp: any) => {
      this.regionList = resp.map((i) => {
        return {
          keyName: i.name,
          sub: i.subRegions.map((i: any) => {
            return { ...i, keyName: i.name };
          }),
        };
      });
    });
    this.getBizInfos();


    this.route.queryParams.subscribe((param) => {
      if (param['page']) {
        this.tabChange(parseInt(param['page']))
      }
    });

    // Store changes
    this.store.pipe(select(selectUser)).subscribe((response: User) => {
      if (response) {
        this.getCertificate()
        const data = response;
        this.userInfo = data;
        this.userCard = this.userInfo?.userCard;
        this.charName = data.profileCharacterName;
        this.email = data?.email;
        this.currentEmail = data?.email;
        this.postalCode = data.postalCode;
        this.currentPostalCode = data.postalCode;
        this.shortDescription = data.shortDescription;
        this.buyerContact = data.buyerContact ? false : true; //the text on the template was change to allow
        this.allowTelegramContact = data.allowTelegramContact;
        this.referralCode = data.referralCode;
        this.level = data.level as number;
        this.allowBotChat = data.allowBotChat;
        this.sendMeEmailWhenNewChatStarts = data.sendMeEmailWhenNewChatStarts;
        this.showCardOnProducts = data.showCardOnProducts;
        this.allowBookDriver = data.allowBookDriver;
        this.addMainAIInMyChat = data.addMainAIInMyChat;
        this.turnOffWhatsapp = data.turnOffWhatsapp ? true : false;
        this.selectedMemberRegion =
          this.commonService.getSubRegionBaseOnPostalCode(
            data.postalCode || ''
          )?.name;
        this.selectedMemberRegionId = data?.region || '';
        this.certifiedValue = JSON.parse(data?.certified ?? '[]');
        this.enableTemplate = data.enableTemplate ? true : false;
        this.noIndexProduct = data.noIndexProduct ? true : false;
        this.turnOffWhatsapp = data.turnOffWhatsapp ? true : false;
        this.bgBody = data.bgBody
        this.numberOfDayForPostalCodeChange =
          this.getNumberOfDaysForPostcodeChange(data?.postalCodeLastUpdated);
        this.hiddenCategoryTab = data.hiddenCategoryTab || (localStorage.getItem("hiddenTab") ?? '')
        if (this.allowTelegramContact && this.buyerContact) {
          this.allowTelegramContact = 0;
        }
        this.allowTelegramContact
        this.categoryTabs.map((row: any) => {
          if (!this.hiddenCategoryTab.includes(row.name)) {
            row.checked = true
          }
        })
        this.charImage.preview = data.characterImageUpload;
        this.charImage.default = data.useCharacterImage;
      }
    });
    this.store
      .pipe(select(selectBizShopBanner))
      .subscribe((response: Array<BizShopBanner>) => {
        this.get_all_product_banner_response = response;
        console.log("banners=", this.get_all_product_banner_response)
      });
  }
  public get_all_product_banner_response = []

  public getNumberOfDaysForPostcodeChange(LastUpdatedPostalCode: any): any {
    let remainingDays = 0;
    if (LastUpdatedPostalCode) {
      try {
        let THREE_MONTHS_MS = 3 * 30 * 24 * 60 * 60 * 1000;
        let lastUpdated: any = new Date(LastUpdatedPostalCode);
        let now = Date.now();
        let remainingTime = THREE_MONTHS_MS - (now - lastUpdated);
        remainingDays = Math.ceil(remainingTime / (24 * 60 * 60 * 1000));
        remainingDays = remainingDays >= 0 ? remainingDays : 0;
      } catch (e) {
        remainingDays = 0;
      }
    }
    return remainingDays;
  }

  goBack() {
    this.commonService.goBack();
  }

  public getTelegramLinks() {
    if (this.userInfo?.isTelegramVerified) {
      return;
    }

    this.auth.get_telegram_verification_link().subscribe((e: any) => {
      this.window.open(`${e.telegramLink}`, '_blank');
    });
  }

  async sendOtp(modal = null) {
    this.isLoading = true;

    const length = 6;
    const otp = Array.from({ length }, () =>
      Math.floor(Math.random() * 10)
    ).join('');

    const data = {
      messaging_product: 'whatsapp',
      recipient_type: 'individual',
      to: `${this.userInfo.countryCode}${this.userInfo.phone}`,
      type: 'template',
      template: {
        name: 'user_otp',
        language: {
          code: 'en_US',
        },
        components: [
          {
            type: 'body',
            parameters: [
              {
                type: 'text',
                text: otp,
              },
            ],
          },
          {
            type: 'button',
            sub_type: 'url',
            index: '0',
            parameters: [
              {
                type: 'text',
                text: otp,
              },
            ],
          },
        ],
      },
    };

    const token = environment.whtsappCloudToken;

    await fetch(environment.whtsappCloudUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });

    await this.http
      .post(environment.baseUrlAdmin + 'member_save_otp_marketplace', {
        phoneNumber: this.userInfo?.phone,
        otp,
      })
      .subscribe((response) => {
      });

    this.isLoading = false;
    this.otpSent = true;

    return true;
  }

  onRegionClick(name) {
    this.selectedMemberRegion = name.name;
    this.selectedMemberRegionId = name.subRegionId;
    try {
      this.postalCode = JSON.parse(name.postalCode).join(',') || '';
    } catch (e) {
      this.postalCode = '';
    }
  }

  public saveProfileInfo(): void {
    // // Validate email using the pattern
    // if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.email)) {
    //   this.toastr.error('Please enter a valid email address.');
    //   return;
    // }

    // if ((this.email && !this.currentEmail) || this.email != this.currentEmail) {
    //   this.saveMemberEmail(this.email);
    // }

    if (this.newNotifVal && 'Notification' in window) {
      Notification.requestPermission().then(() => {
        this.notificationService.registerDevice();
      });
    }

    let payload = {
      profileCharacterName: this.charName,
      shortDescription: this.shortDescription,
      certifiedValue: JSON.stringify(this.certifiedValue),
      region: this.selectedMemberRegionId,
      buyerContact: this.buyerContact ? 0 : 1, //did this because the text is changed
      turnOffWhatsapp: this.turnOffWhatsapp ? 1 : 0,
      theme: this.userInfo?.theme,
      bgBody: this.bgBody,
      showMeNotificationWeb: this.newNotifVal ? 1 : 0,
      enableTemplate: this.enableTemplate ? 1 : 0,
      noIndexProduct: this.noIndexProduct ? 1 : 0,
      allowTelegramContact: this.allowTelegramContact ? 1 : 0,
      allowBotChat: this.allowBotChat,
      sendMeEmailWhenNewChatStarts: this.sendMeEmailWhenNewChatStarts,
      showCardOnProducts: this.showCardOnProducts,
      allowBookDriver: this.allowBookDriver ? 1 : 0,
      addMainAIInMyChat: this.addMainAIInMyChat ? 1 : 0,
      hiddenCategoryTab: this.hiddenCategoryTab,
      characterImageUpload: this.charImage.file,
      characterImageUploadDefault: this.charImage.default,
    };


    if (this.postalCode != this.currentPostalCode) {
      if (this.postalCode.length != 6) {
        this.toastr.error('Postal code should be 6 digits');
        return;
      }
      payload['postalCode'] = this.postalCode;
    }

    const formData = new FormData

    Object.keys(payload)
      .map((row) => {
        formData.append(row, payload[row])
      })

    this.auth.updateProfileCharacterDetails(formData).subscribe(
      (resp: ApiResponse) => {
        if (resp.message) {
          this.toastr.success(resp.message);
          this.store.dispatch(loadUser({}));
          this.chatbotService.getAllChats();
          this.handleSessionData()
        }
      },
      ({ error }) => {
        this.toastr.error(error.message);
      }
    );
  }

  public handleSessionData() {
    const user = this.local.loadUser()
    if (user?.id) {
      this.local.saveLoginUserData({
        ...user,
        hiddenCategoryTab: this.hiddenCategoryTab
      })
    }
  }

  public handleHideCategoryTab(category: any) {
    const name = `${category.name}|`
    this.hiddenCategoryTab = this.hiddenCategoryTab.replaceAll(name, '')
    if (!category.checked) {
      this.hiddenCategoryTab += name
    }
    if (this.sharedService.isBrowser()) localStorage.setItem('hiddenTab', this.hiddenCategoryTab)
  }

  public saveMemberEmail(email) {
    this.customerService
      .saveMemberEmail({
        email: email,
      })
      .subscribe(
        (resp: ApiResponse) => {
          if (resp.message) {
            this.toastr.success(resp.message);
            this.store.dispatch(loadUser({}));
          }
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  onThemeChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const theme = selectElement.value;
    localStorage.setItem('selectedTheme', theme);
    if (this.userInfo.theme) {
      document.documentElement.classList.remove(this.userInfo.theme);
    }
    document.documentElement.classList.add(theme);
    //this.selectedTheme = theme;
  }
  onBgBodyChange(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const theme = selectElement.value;
    // localStorage.setItem('selectedTheme', theme);
    if (this.bgBody) {
      // document.body.classList.remove(this.bgBody);
    }
    // document.body.classList.add(theme);
  }
  onTutorialsChange(event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;
    localStorage.setItem('tutorials', JSON.stringify(isChecked));
    this.tutorials = isChecked;
  }

  public otpSent: boolean = false;
  public otp: string = '';
  public passcode: string = '';
  public passcodeConfirm: string = '';
  public isLoading: boolean = false;
  public otpError: string = '';
  public isReset: boolean = false;

  delaySendOTP: number = 0;
  handleSendOTP() {
    if (this.delaySendOTP < 1)
      this.auth
        .member_send_otp({
          phone: this.userInfo?.phone,
        })
        .subscribe(
          (resp: any) => {
            const result = resp.body;
            if (result.success) {
              this.toastr.success(resp.message);
            } else {
              this.toastr.error(resp.message);
            }
            this.delaySendOTP = 61;
            let interval = setInterval(() => {
              this.delaySendOTP -= 1;
              if (this.delaySendOTP == 0) {
                clearInterval(interval);
              }
            }, 1000);
          },
          () => {
            this.toastr.error('Internal Server Error');
          }
        );
  }

  handleVerify() {
    if (this.passcode == '') return this.toastr.error('Please Fill Passcode');
    if (this.passcode != this.passcodeConfirm) {
      return this.toastr.error("Passcode Confirmation Doesn't Match");
    }

    if (this.otp == '') return this.toastr.error('Please Fill OTP');

    this.auth
      .member_reset_passcode({
        password: this.passcode,
        otp: this.otp,
        phone: this.userInfo?.phone,
      })
      .subscribe(
        (resp: any) => {
          const result = resp.body;
          if (result.success) {
            this.toastr.success(resp.message);
          } else {
            this.toastr.error(resp.message);
          }
        },
        () => {
          this.toastr.error('Internal Server Error');
        }
      );
  }

  async onChangeOtp(e: any) {
    this.otp = e.target.value;
  }

  async onChangePasscode(e: any) {
    this.passcode = e.target.value;
  }

  public verifyEmailOtp() {
    if (this.selectedOTP && this.selectedOTP.length == 6) {
      this.customerService
        .verifyEmailOtp({
          otp: this.selectedOTP,
          email: this.email,
        })
        .subscribe(
          (resp: ApiResponse) => {
            if (resp.message) {
              this.notificationService.notifyUser('Email', resp.message);
              this.modalRef ? this.modalRef.close() : '';
              this.store.dispatch(loadUser({}));
            }
          },
          ({ error }) => {
            this.toastr.error(error.message);
          }
        );
    } else {
      this.toastr.error('Invalid OTP!');
    }
  }

  public removecard(modal: any) {
    this.selectedOTP = '';
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'remove-card my-modal sm',
    });
  }

  public openAISettingTab(modal: any) {
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'aisetting-modal my-modal sm',
    });
  }

  public async removecardconfirm() {
    this.customerService
      .removeCard({
        type: 'user',
      })
      .subscribe(
        (resp: any) => {
          if (resp.message.trim() == 'Card Removed.') {
            this.userCard = false;
            this.toastr.success(resp.message);
            this.modalRef ? this.modalRef.close() : '';
          } else {
            this.toastr.error(resp.message);
          }
        },
        ({ error }) => {
          this.toastr.error(error.message);
        }
      );
  }

  public handleOTPVerification(modal: any) {
    this.selectedOTP = '';
    this.modalRef = this.modalService.open(modal, {
      size: 'sm',
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'otp-verification my-modal sm',
    });
  }

  public ignoreTag(tag) {
    this.customerService.updateTag({ ignoreTag: tag }).subscribe(() => {
      this.toastr.success('Tag remove successfully');
      this.commonService.getTagList();
    });
  }

  public sendEmailOtp() {
    if (this.delaySendOTP < 1)
      this.customerService
        .saveMemberEmail({
          email: this.email,
        })
        .subscribe(
          (resp: any) => {
            this.toastr.success(resp.message);
            this.store.dispatch(loadUser({}));
            this.delaySendOTP = 61;
            let interval = setInterval(() => {
              this.delaySendOTP -= 1;
              if (this.delaySendOTP == 0) {
                clearInterval(interval);
              }
            }, 1000);
          },
          ({ error }) => {
            this.toastr.error(error.message);
          }
        );
  }

  subscribeto(token, subc = 0, notification_code = 'DEFAULT') {
    if ((this.userInfo?.level ?? 1) < 5) return;
    let stripe_price_id = '';
    let tokens = 'diamond';
    let sub_type = '0';
    if (token == 1) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgRBHqb9USI';
      //  stripe_price_id = 'price_1PXB9j03HSHmHwgRqY423W2q'; // test // 10
    } else if (token == 2) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgR4pUGQMcJ';
      // stripe_price_id = 'price_1PXBA703HSHmHwgRrGsz1caP'; // test // 50
    } else if (token == 3) {
      stripe_price_id = 'price_1PXDlJ03HSHmHwgRSrdF2phA';
      // stripe_price_id = 'price_1PXBAF03HSHmHwgRreL0wkSJ'; // test // 100
    } else if (token == 4) {
      sub_type = '2';
      tokens = 'diamonds';
      stripe_price_id = 'price_1PuwKW03HSHmHwgR4jPGT6ej'; // 29.9
      // stripe_price_id = 'price_1Pp7id03HSHmHwgRH52LRKDp'; // test // 9.9
    } else if (token == 5) {
      sub_type = '2';
      tokens = 'diamonds';
      stripe_price_id = 'price_1Pp7e703HSHmHwgRKIcJ510D';
      //  stripe_price_id = 'price_1Pp7il03HSHmHwgRIlcMGwcI'; // test // 9.9
    } else if (token == 6) {
      sub_type = '2';
      tokens = 'diamonds';
      stripe_price_id = 'price_1PuweG03HSHmHwgRqFynyOqj'; // 39.9
      //  stripe_price_id = 'price_1Pp7iu03HSHmHwgRqjNLKW0T'; // test // 29.9
    }

    let formData = new FormData();
    formData.append('id', this.userInfo?.id);
    formData.append('stripe_price_id', stripe_price_id);
    formData.append('tokens', tokens);
    formData.append('token', token);
    formData.append('sub', subc.toString());
    formData.append('notification_code', notification_code);
    formData.append('sub_type', sub_type);

    this.auth.create_stripe_checkout_url(formData).subscribe(
      (response: any) => {
        if (response.body.url != 'r') this.window.location.href = response.body.url;
        else if (response.body.message != '') {
          if (response.body.code == 0) {
            this.subscribeto(token, 1, response.body.notification_code);
            return;
          }
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
  managesub() {
    if ((this.userInfo?.level ?? 1) < 5) return;

    let stripe_price_id = 'xxx';
    let tokens = 'diamond';
    let sub_type = '0';

    let formData = new FormData();
    formData.append('id', this.userInfo?.id);
    formData.append('stripe_price_id', stripe_price_id);
    formData.append('tokens', 'xxxx');
    formData.append('notification_code', 'xxx');
    formData.append('sub_type', '3');

    this.auth.create_stripe_checkout_url(formData).subscribe(
      (response: any) => {
        if (response.body.url != 'r') this.window.location.href = response.body.url;
        else if (response.body.message != '') {
          if (response.body.code == 0) {
            this.subscribeto(response.body.notification_code);
            return;
          }
        }
      },
      (e) => {
        if (e.status == 400) {
          this.toastr.error(e.error.message);
        }
      }
    );
  }
  public isPostalConfirmed: boolean = false;
  public filterSubregions() {
    if (this.isPostalConfirmed) {
      this.isConfirm();
    } else {
      this.local
        .alertConfirm({
          message: `All Product will be Delisted, Are you sure want to change postal code ?`,
        })
        .then((resp) => {
          if (resp.isConfirmed) {
            this.isPostalConfirmed = true;
            this.isConfirm();
          } else {
            this.postalCode = this.currentPostalCode;
          }
        });
    }
  }

  public isConfirm() {
    let region =
      this.commonService.getSubRegionBaseOnPostalCode(this.postalCode) || '';
    this.selectedMemberRegion = region ? region.name : '';
    this.selectedMemberRegionId = region ? region.subRegionId : '';
  }

  registeredBotToken?: string | null = null;
  registeredBotUsername?: string | null = null;

  isBotInfoLoading: boolean = false;
  isBotRegisterationError: boolean = false;
  isBotBeingEdited: boolean = false;

  telegramUserId?: string | null = null;
  telegramUserFullName?: string | null = null;
  telegramUsername?: string | null = null;

  isTelegramUserError: boolean = false;
  private registerationUUID: string = '';

  openRegistration() {
    this.window.open(
      `https://t.me/${this.registeredBotUsername}?start=reg-${this.registerationUUID}`,
      '_blank'
    );
    setTimeout(() => {
      this.getBitTelegramRegisteration();
    }, 10000);
  }

  // constructor(private auth: AuthServiceService, private toast: ToastrService) {}

  candidateBotToken: string = '';

  getBitTelegramRegisteration() {
    this.isBotInfoLoading = true;
    this.customerService.getTgBotRegistration().subscribe({
      next: (rv: any) => {
        this.isBotInfoLoading = false;

        if (!rv.ok) {
          this.isBotRegisterationError = true;
          // this.toastr.error(
          //   'Error while loading old bot token registeration. Please register again'
          // );
          return;
        }
        this.registeredBotToken = rv?.data?.tgToken;
        this.registeredBotUsername = rv?.bot?.username;
        this.isTelegramUserError = rv?.isUserError;
        if (!rv?.isUserError && rv?.telegramUser) {
          this.telegramUserId = rv?.telegramUser?.id + '';
          this.telegramUsername = rv?.telegramUser?.username;
          this.telegramUserFullName = `${rv?.telegramUser?.first_name ?? ' '} ${rv?.telegramUser?.last_name ?? ' '
            }`;
        }
        this.registerationUUID = rv?.data?.linkUUId;
      },
      error: (err) => {
        console.error(err);
        // this.toastr.error(
        //   'Error while loading. please try again latter: ' + err.message
        // );
        this.isBotInfoLoading = false;
      },
    });
  }

  updateTelegramBotRegisteration() {
    this.customerService.registerTgBot(this.candidateBotToken).subscribe({
      next: (rv: any) => {
        this.toastr.show('Registeration successful!');
        //setTimeout(this.getBitTelegramRegisteration, 5000);
        this.getBitTelegramRegisteration();
        this.isBotBeingEdited = false;
      },
      error: (err) => {
        console.error(err);
        this.toastr.error('Error while loading. pleast try again latter');

        // this.getBitTelegramRegisteration();
        this.isBotBeingEdited = false;
      },
    });
  }

  public updateCertificate(value) {
    this.certifiedValue = value.value || [];
  }
}
